import CamposSaida from './services/CamposSaida'
import Debug from './services/Debug'
import Processamento from './services/Processamento'
import Templates from './services/Templates'

export default {
  CamposSaida,
  Debug,
  Processamento,
  Templates,
}
